export const app = {
  version: '1.40.0',
};
